import { render, staticRenderFns } from "./ConfigPriority.vue?vue&type=template&id=525341aa&"
import script from "./ConfigPriority.vue?vue&type=script&lang=js&"
export * from "./ConfigPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports